import { React, useEffect, useState, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Radio,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { useLocation, useNavigate } from "react-router";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";

import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import { capital_letter } from "../../../Utils/helper/helper";
import { addCutter, deleteCutterByCode, getAllCutter, getCuttersByCode, updateCutterByCode } from "../../../Services/machineServices";
import {
  CoversionFactorCMToUnits, CoversionFactorUnitsToCM, lengthUnit
  , weightUnit
} from '../../../Utils/Constant/MeasurementUnitList.jsx';
import { getUnitData } from "../../../Services/measurementService";

const { Option } = Select;

const statusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];
const cutterTypeData = [
  { label: "Simplex", value: "simplex" },
  { label: "Duplex", value: "duplex" },
];

const { TextArea } = Input;

const AddEditViewCutter = (props) => {
  const location = useLocation();
  const [status, setStatus] = useState(statusData[0].value);
  const [cutterType, setCutterType] = useState(cutterTypeData[0].value);
  const [gsmValidationError, setGSMValidationError] = useState(false);
  const [widthValidationError, setWidthValidationError] = useState(false);
  const [edgeTrimValidationError, setEdgeTrimValidationError] = useState(false);
  const [selectedLengthUnit, setSelectedLengthUnit] = useState();
  const selectedEdgeUnit = useRef("cm");
  const history = useNavigate();
  const deckleWidthUnitData = ["mm", "cm"];
  const [form] = Form.useForm();
  const [chopSizeValidationError, setChopSizeValidationError] = useState(false);
  const [stationOneWidthValidationError1, setStationOneWidthValidationError1] = useState(false);
  const [stationOneWidthValidationError2, setStationOneWidthValidationError2] = useState(false);
  const [chopSizeStation1ValidationError, setChopSizeStation1ValidationError] = useState(false);
  const [maxCuttersStation1ValidationError, setMaxCuttersStation1ValidationError] = useState(false);
  const [stationTwoWidthValidationError1, setStationTwoWidthValidationError1] = useState(false);
  const [stationTwoWidthValidationError2, setStationTwoWidthValidationError2] = useState(false);
  const [chopSizeStation2ValidationError, setChopSizeStation2ValidationError] = useState(false);
  const [maxCuttersStation2ValidationError, setMaxCuttersStation2ValidationError] = useState(false);
  const [maxDiaValidationError, setMaxDiaValidationError] = useState(false);
  const [action, setAction] = useState(location.state.action);
  const [allCutterData, setAllCutterData] = useState([]);
  const [cutterDetails, setCutterDetails] = useState();
  const [visible, setVisible] = useState(false);
  const [viewDelete, setViewDelete] = useState(false);
  const [addToastr, setAddToastr] = useState(false);
  const [addResp, setAddResp] = useState();
  const [unitData, setUnitData] = useState();
  const [deleteToastr, setDeleteToastr] = useState(false);
  const [zeroEdgeTrimConfig, setZeroEdgeTrimConfig] = useState(false);

  useEffect(() => {
    (async () => {

      getUnitData().then((response) => {
        setUnitData(response.data);
        if (action == 'add') {
          setSelectedLengthUnit(response.data.units_management.length.default);
        }
      })
        .catch((error) => {
          console.log(error);
        });

      await getAllCutter()
        .then((response) => {
          setAllCutterData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });

      if (action === "view" || action === 'edit') {

        await getCuttersByCode(location.state.code)
          .then((response) => {
            setCutterType(response.data.type);
            setCutterDetails(response.data);
            setZeroEdgeTrimConfig(response.data.zero_edge_trim);
            form.setFieldsValue({
              zero_edge_trim_config: response.data.zero_edge_trim
            });
            setSelectedLengthUnit(response.data.units.effective_deckle_length);
          })
          .catch((error) => {
            console.log(error);
          });


      }
    })();
  }, []);

  const routeBack = (action, response) => {
    history("../cutter-records/");
  };

  const validateMinMaxChopSize = () => {
    if (
      form.getFieldValue("minimum_chop_size") &&
      form.getFieldValue("maximum_chop_size") &&
      parseFloat(form.getFieldValue("maximum_chop_size")) <
      parseFloat(form.getFieldValue("minimum_chop_size"))
    ) {
      setChopSizeValidationError(true);
    } else {
      setChopSizeValidationError(false);
    }
  }

  const validateMinMaxGSM = () => {
    if (
      form.getFieldValue("minimum_gsm") &&
      form.getFieldValue("maximum_gsm") &&
      parseFloat(form.getFieldValue("maximum_gsm")) <
      parseFloat(form.getFieldValue("minimum_gsm"))
    ) {
      setGSMValidationError(true);
    } else {
      setGSMValidationError(false);
    }
  };

  const validateEdgeTrim = () => {
    let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
    let edgeDivisor = CoversionFactorUnitsToCM[form.getFieldValue("edge_unit")];
    if (
      form.getFieldValue("left_edge_trim") &&
      form.getFieldValue("right_edge_trim") &&
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width") &&
      (parseFloat(form.getFieldValue("left_edge_trim")) * edgeDivisor + parseFloat(form.getFieldValue("right_edge_trim")) * edgeDivisor) >=
      parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor - parseFloat(form.getFieldValue("minimum_width")) * lengthDivisor
    ) {
      setEdgeTrimValidationError(true);
    } else {
      setEdgeTrimValidationError(false);
    }
    calculateEffectiveLength();
  };

  const validateWidth = () => {
    if (
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width") &&
      parseFloat(form.getFieldValue("maximum_width")) <
      parseFloat(form.getFieldValue("minimum_width"))
    ) {
      setWidthValidationError(true);
    } else {
      setWidthValidationError(false);
    }
    validateEdgeTrim();
    calculateEffectiveLength();
    calculateMaxTrimLoss();
    stationOneWidthValidation();
    station2WidthValidation();
  };

  const validateMinMaxDia = () => {
    if (
      form.getFieldValue("minimum_dia_range") &&
      form.getFieldValue("maximum_dia_range") &&
      parseFloat(form.getFieldValue("maximum_dia_range")) <
      parseFloat(form.getFieldValue("minimum_dia_range"))
    ) {
      setMaxDiaValidationError(true);
    } else {
      setMaxDiaValidationError(false);
    }
  };

  const calculateEffectiveLength = () => {
    if (
      form.getFieldValue("left_edge_trim") &&
      form.getFieldValue("right_edge_trim") &&
      form.getFieldValue("maximum_width")
    ) {
      let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
      let edgeDivisor = CoversionFactorUnitsToCM[form.getFieldValue("edge_unit")];
      let length = (parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor) - ((parseFloat(form.getFieldValue("left_edge_trim")) * edgeDivisor) + (parseFloat(form.getFieldValue("right_edge_trim")) * edgeDivisor));
      form.setFieldsValue({ effective_deckle_length: (CoversionFactorCMToUnits[form.getFieldValue("length_unit")] * length).toFixed(3) })
    }
  };

  const calculateMaxTrimLoss = () => {
    if (
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width")) {
      let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
      form.setFieldsValue({ maximum_loss: (([parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor - parseFloat(form.getFieldValue("minimum_width")) * lengthDivisor] * 100) / (parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor)).toFixed(3) });
    }
  };

  const onLengthUnitChange = (e) => {
    form.setFieldsValue({ edge_unit: e });

    if (cutterType === "simplex") {
      form.setFieldsValue({ chop_unit: e })
    }
    if (cutterType === "duplex") {
      form.setFieldsValue({ station1_chop_unit: e, station2_chop_unit: e });
    }

    setSelectedLengthUnit(e);
    validateEdgeTrim();
    validateWidth();
    calculateEffectiveLength();
    calculateMaxTrimLoss();
    stationOneWidthValidation();
    station2WidthValidation();
  }

  const onEdgeUnitChange = (e) => {
    selectedEdgeUnit.current = e;
    validateEdgeTrim();
    validateWidth();
    calculateMaxTrimLoss();
    calculateEffectiveLength();
  }

  const stationOneWidthValidation = () => {
    let station1WidthDivisor = CoversionFactorCMToUnits[form.getFieldValue("station1_width_unit")];
    let deckleWidthDivisor = CoversionFactorCMToUnits[form.getFieldValue("length_unit")];

    if (
      form.getFieldValue("maximum_width_station_1") &&
      form.getFieldValue("minimum_width_station_1") &&
      ((parseFloat(form.getFieldValue("maximum_width_station_1")) * station1WidthDivisor) <
        (parseFloat(form.getFieldValue("minimum_width_station_1")) * station1WidthDivisor))
    ) {
      setStationOneWidthValidationError1(true);
    } else {
      setStationOneWidthValidationError1(false);
    }

    if (
      form.getFieldValue("maximum_width_station_1") &&
      form.getFieldValue("maximum_width") &&
      parseFloat(form.getFieldValue("maximum_width_station_1")) * station1WidthDivisor >
      parseFloat(form.getFieldValue("maximum_width")) * deckleWidthDivisor
    ) {
      setStationOneWidthValidationError2(true);
    } else {
      setStationOneWidthValidationError2(false);
    }

  }

  const validateStation1MinMaxChopSize = () => {
    if (
      form.getFieldValue("maximum_chop_size_station_1") &&
      form.getFieldValue("minimum_chop_size_station_1") &&
      parseFloat(form.getFieldValue("maximum_chop_size_station_1")) <
      parseFloat(form.getFieldValue("minimum_chop_size_station_1"))
    ) {
      setChopSizeStation1ValidationError(true);
    } else {
      setChopSizeStation1ValidationError(false);
    }
  }

  const maxCutterValidation = (e) => {
    if (cutterType === "duplex") {
      form.setFieldsValue({ maximum_cutters_station_2: e.target.value });
      form.setFieldsValue({ maximum_cutters_station_1: e.target.value });
      setMaxCuttersStation1ValidationError(false);
      setMaxCuttersStation2ValidationError(false);
    }
  }

  const station1MaxCutterValidation = () => {
    if (form.getFieldValue("maximum_cutters") && form.getFieldValue("maximum_cutters_station_1") &&
      parseFloat(form.getFieldValue("maximum_cutters")) < parseFloat(form.getFieldValue("maximum_cutters_station_1"))
    ) {
      setMaxCuttersStation1ValidationError(true);
    } else {
      setMaxCuttersStation1ValidationError(false);
    }
    station2MaxCutterValidation();
  }

  const station2WidthValidation = () => {
    let station2WidthDivisor = CoversionFactorCMToUnits[form.getFieldValue("station2_width_unit")];
    let deckleWidthDivisor = CoversionFactorCMToUnits[form.getFieldValue("length_unit")];

    if (
      form.getFieldValue("maximum_width_station_2") &&
      form.getFieldValue("minimum_width_station_2") &&
      ((parseFloat(form.getFieldValue("maximum_width_station_2")) * station2WidthDivisor) <
        (parseFloat(form.getFieldValue("minimum_width_station_2")) * station2WidthDivisor))
    ) {
      setStationTwoWidthValidationError1(true);
    } else {
      setStationTwoWidthValidationError1(false);
    }

    if (
      form.getFieldValue("maximum_width_station_2") &&
      form.getFieldValue("maximum_width") &&
      parseFloat(form.getFieldValue("maximum_width_station_2")) * station2WidthDivisor >
      parseFloat(form.getFieldValue("maximum_width")) * deckleWidthDivisor
    ) {
      setStationTwoWidthValidationError2(true);
    } else {
      setStationTwoWidthValidationError2(false);
    }

  }

  const validateStation2MinMaxChopSize = () => {
    if (
      form.getFieldValue("maximum_chop_size_station_2") &&
      form.getFieldValue("minimum_chop_size_station_2") &&
      parseFloat(form.getFieldValue("maximum_chop_size_station_2")) <
      parseFloat(form.getFieldValue("minimum_chop_size_station_2"))
    ) {
      setChopSizeStation2ValidationError(true);
    } else {
      setChopSizeStation2ValidationError(false);
    }
  }

  const station2MaxCutterValidation = () => {
    if (
      form.getFieldValue("maximum_cutters") &&
      form.getFieldValue("maximum_cutters_station_2") &&
      parseFloat(form.getFieldValue("maximum_cutters")) <
      parseFloat(form.getFieldValue("maximum_cutters_station_2"))
    ) {
      setMaxCuttersStation2ValidationError(true);
    } else {
      setMaxCuttersStation2ValidationError(false);
    }
  }

  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    routeBack();
  };

  const modalShowDelete = () => {
    setViewDelete(true);
  };

  const modalCancelDelete = () => {
    setViewDelete(false);
  };

  const onSetCutterType = (e) => {
    setCutterType(e.target.value);
    if (form.getFieldValue("maximum_cutters") && e.target.value === "duplex") {
      form.setFieldsValue({ maximum_cutters_station_2: form.getFieldValue("maximum_cutters") });
      form.setFieldsValue({ maximum_cutters_station_1: form.getFieldValue("maximum_cutters") });
      setMaxCuttersStation1ValidationError(false);
      setMaxCuttersStation2ValidationError(false);
    }
  };

  const modalConfirmDelete = (code) => {
    // deleteCustomerRecord(code);

    setViewDelete(false);
    deleteCutterByCode(cutterDetails.code)
      .then((response) => {
        setAddResp(response.msg);
        setAddToastr(true);
        setTimeout(() => {
          setAddToastr(false);
          history("../cutter-records")
        }, 2000);
      })
      .catch((error) => {
        // console.log(error);
        // setAddResp(error.response.data.msg);
        setDeleteToastr(true);
        // setTimeout(() => {
        //   setDeleteToastr(false);
        // }, 2000);

        if (error?.response?.status == 500) {
          setAddResp("Something went wrong. Please try again");
        } else {
          setAddResp(error?.response?.data?.msg);
        }

        setTimeout(() => {
          setDeleteToastr(false);
          setAddResp("");
        }, 2000);
      });

  };

  const handleEdit = () => {
    setAction("edit");
  }

  const handleSubmit = () => {
    if (!gsmValidationError && !widthValidationError && !edgeTrimValidationError && !chopSizeValidationError
      && !stationOneWidthValidationError1 && !stationOneWidthValidationError2 && !maxCuttersStation1ValidationError
      && !stationTwoWidthValidationError1 && !stationTwoWidthValidationError2 && !maxCuttersStation2ValidationError
      && !chopSizeStation1ValidationError && !chopSizeStation2ValidationError && !maxDiaValidationError) {
      form.submit();
    }
  }


  const onFinish = (e) => {
    let req = {
      effective_deckle_length: parseFloat(e.effective_deckle_length),
      left_edge_trim: parseFloat(e.left_edge_trim),
      right_edge_trim: parseFloat(e.right_edge_trim),
      maximum_cutters: parseFloat(e.maximum_cutters),
      maximum_gsm: parseFloat(e.maximum_gsm),
      maximum_loss: parseFloat(e.maximum_loss).toFixed(3),
      maximum_width: parseFloat(e.maximum_width),
      minimum_gsm: parseFloat(e.minimum_gsm),
      minimum_width: parseFloat(e.minimum_width),
      minimum_reel_dia: parseFloat(e.minimum_dia_range),
      maximum_reel_dia: parseFloat(e.maximum_dia_range),
      capacity: parseFloat(e.capacity),
      loading_stands: parseInt(e.loading_stands),
      name: capital_letter(e.name),
      remarks: e.remarks,
      status: e.status,
      type: e.type,
      zero_edge_trim: zeroEdgeTrimConfig,
      units: {
        effective_deckle_length: form.getFieldValue("length_unit"),
        left_edge_trim: form.getFieldValue("edge_unit"),
        right_edge_trim: form.getFieldValue("edge_unit"),
        maximum_width: form.getFieldValue("length_unit"),
        minimum_width: form.getFieldValue("length_unit"),
        capacity: form.getFieldValue("capacity_unit"),
        minimum_reel_dia: form.getFieldValue("dia_unit"),
        maximum_reel_dia: form.getFieldValue("dia_unit"),
      }
    }

    if (cutterType === "simplex") {
      req["maximum_chop_size"] = parseFloat(e.maximum_chop_size);
      req["minimum_chop_size"] = parseFloat(e.minimum_chop_size);
      req.units['maximum_chop_size'] = e.chop_unit;
      req.units['minimum_chop_size'] = e.chop_unit;

    }
    else {
      req["maximum_difference_chop_size"] = parseFloat(e.maximum_difference_chop_size);
      req["minimum_width_station_1"] = parseFloat(e.minimum_width_station_1);
      req["maximum_width_station_1"] = parseFloat(e.maximum_width_station_1);
      req["maximum_cutters_station_1"] = parseFloat(e.maximum_cutters_station_1);
      req["minimum_chop_size_station_1"] = parseFloat(e.minimum_chop_size_station_1);
      req["maximum_chop_size_station_1"] = parseFloat(e.maximum_chop_size_station_1);
      req["minimum_width_station_2"] = parseFloat(e.minimum_width_station_2);
      req["maximum_width_station_2"] = parseFloat(e.maximum_width_station_2);
      req["maximum_cutters_station_2"] = parseFloat(e.maximum_cutters_station_2);
      req["minimum_chop_size_station_2"] = parseFloat(e.minimum_chop_size_station_2);
      req["maximum_chop_size_station_2"] = parseFloat(e.maximum_chop_size_station_2);
      req.units['maximum_difference_chop_size'] = e.max_chop_unit;
      req.units['minimum_width_station_1'] = e.station1_width_unit;
      req.units['maximum_width_station_1'] = e.station1_width_unit;
      req.units['minimum_chop_size_station_1'] = e.station1_chop_unit;
      req.units['maximum_chop_size_station_1'] = e.station1_chop_unit;
      req.units['minimum_width_station_2'] = e.station2_width_unit;
      req.units['maximum_width_station_2'] = e.station2_width_unit;
      req.units['minimum_chop_size_station_2'] = e.station2_chop_unit;
      req.units['maximum_chop_size_station_2'] = e.station2_chop_unit;
    }

    if (action === 'add') {
      addCutter(req)
        .then((response) => {
          setAddResp(response.msg);
          setAddToastr(true);
          setTimeout(() => {
            setAddToastr(false);
            history("../cutter-records")
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          setDeleteToastr(true);
          if (error?.response?.status == 500) {
            setAddResp("Something went wrong. Please try again");
          } else {
            setAddResp(error?.response?.data?.msg);
          }

          setTimeout(() => {
            setDeleteToastr(false);
            setAddResp("");
          }, 2000);

        });
    }

    if (action === "edit") {
      updateCutterByCode(cutterDetails.code, req)
        .then((response) => {
          setAddResp(response.msg);
          setAddToastr(true);
          setTimeout(() => {
            setAddToastr(false);
            history("../cutter-records")
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          setDeleteToastr(true);
          if (error?.response?.status == 500) {
            setAddResp("Something went wrong. Please try again");
          } else {
            setAddResp(error?.response?.data?.msg);
          }

          setTimeout(() => {
            setDeleteToastr(false);
            setAddResp("");
          }, 2000);
        });
    }


  }

  return (((action === "view" || action === "edit") && cutterDetails) ||
    action === "add") && unitData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={action === "view" && routeBack}
          title={action === "add" ? "Add a new cutter" : cutterDetails.name}
          extra={
            action === "add"
              ? [
                <Button key="1" className="textTypeBtn" onClick={modalShow}>
                  Cancel changes
                </Button>,
                <Button key="2" className="themeBtn" onClick={handleSubmit}>
                  <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                  Add Cutter
                </Button>,
              ]
              : action === "edit"
                ? [
                  <Button key="1" className="textTypeBtn" onClick={modalShow}>
                    Cancel changes
                  </Button>,
                  <Button key="3" className="themeBtn" onClick={handleSubmit}>
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Save Cutter
                  </Button>,
                ]
                : [
                  <Button
                    key="8"
                    className="themeBtn noBg"
                    onClick={modalShowDelete}
                  // disabled={!roles.edit}
                  >
                    <Iconmoon icon="delete" size={14} color="#EA655B" />
                    Delete Cutter
                  </Button>,
                  <Button
                    key="5"
                    className="themeBtn"
                    onClick={handleEdit}
                  //disabled={!roles.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Edit Cutter
                  </Button>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details of cutter will be used in deckle
                      matchinng records and reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {action !== "add" && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Cutter Code</label>
                          <p>This is an auto generated code to uniquely identify
                            the cutter</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="code"
                            // rules={[{ required: true }]}
                            initialValue={cutterDetails?.code}
                            className=""
                          >
                            <Input disabled />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Cutter Name</label>
                        <p>The cutter will be identified by this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message:
                                "Name can have a maximum of 50 characters",
                            },
                            {
                              validator(_, value) {
                                if (cutterDetails) {
                                  if (value === cutterDetails.name)
                                    return Promise.resolve();
                                }
                                if (
                                  value == null ||
                                  !allCutterData.filter((data) => data.name.toUpperCase() === value.toUpperCase()).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This name exists for another cutter"
                                  );
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : cutterDetails.name
                          }
                          className=""
                        >
                          <Input
                            placeholder={

                              "Enter name of the cutter"
                            }
                            style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Type of Cutter</label>
                        <p>
                          The cutter can be of simplex or duplex type
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={cutterType}
                        >
                          <Radio.Group
                            disabled={action === "view"}
                            options={cutterTypeData}
                            value={cutterType}
                            optionType="button"
                            buttonStyle="solid"
                            onChange={(e) => onSetCutterType(e)}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Deckle Specification</h2>
                    <p>
                      The deckle specification will be used to decide what can
                      be processed on this cutter
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>GSM Range</label>
                        <p>The cutter can process paper of this GSM range</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DisabledStyles>
                              <Form.Item
                                name="minimum_gsm"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                    message:
                                      "Only numeric characters are allowed upto 3 decimal points",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Min. GSM cannot be zero",
                                  // },
                                  {
                                    validator(_, value) {
                                      if (value && value == 0) {
                                        return Promise.reject(
                                          "Min. GSM cannot be zero"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : cutterDetails?.minimum_gsm
                                }
                                className=""
                              >
                                <Input
                                  placeholder={"Min GSM"}
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  onChange={validateMinMaxGSM}
                                //style={{ textTransform: "capitalize" }}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="maximum_gsm"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                    message:
                                      "Only numeric characters are allowed upto 3 decimal points",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Max. GSM cannot be zero",
                                  // },
                                  {
                                    validator(_, value) {
                                      if (value && value == 0) {
                                        return Promise.reject(
                                          "Max. GSM cannot be zero"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : cutterDetails?.maximum_gsm
                                }
                                className=""
                              >
                                <Input
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  placeholder={"Max GSM"}
                                  onChange={validateMinMaxGSM}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                        </Col>
                        {gsmValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max GSM cannot be less than Min GSM
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Deckle Width Range</label>
                        <p>
                          The minimum and maximum deckle width of this rewinder
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_width"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                                // {
                                //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                //   message: "Min. width cannot be zero",
                                // },
                                {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Min. width cannot be zero"
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              className=""
                              //onChange={setTrimLoss}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : cutterDetails?.minimum_width
                              }
                            >
                              <Input
                                placeholder="Min width"
                                onChange={validateWidth}
                                disabled={action == "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_width"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                                // {
                                //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                //   message: "Max. width cannot be zero",
                                // },
                                {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Max. width cannot be zero"
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : cutterDetails?.maximum_width
                              }
                              className=""
                            //onChange={setTrimLoss}
                            >
                              <Input
                                placeholder="Max width"
                                disabled={action == "view"}
                                onChange={validateWidth}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="length_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_width}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                onChange={onLengthUnitChange}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>
                                    {lengthUnit[deckleWidth].displayName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        {widthValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max width cannot be less than Min width
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Edge Trim</label>
                        <p>
                          Default left and right edge trim on the cutter
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="left_edge_trim"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action === "add" ? "" : cutterDetails.left_edge_trim
                              }
                            >
                              <Input placeholder="Left Trim"
                                onChange={validateEdgeTrim}
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="right_edge_trim"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""

                              initialValue={
                                action === "add" ? "" : cutterDetails.right_edge_trim
                              }
                            >
                              <Input placeholder="Right Trim"
                                onChange={validateEdgeTrim}
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="edge_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.left_edge_trim}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                disabled={action === "view"}
                                onChange={onEdgeUnitChange}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {edgeTrimValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Total edge trim should be less than difference of
                            deckle range
                          </span>
                        ) : null}
                        <Col span={24} style={{ marginTop: "8px" }}>
                          <Form.Item
                            name="zero_edge_trim_config"
                            valuePropName="checked"
                            initialValue={
                              action === "add"
                                ? false
                                : (zeroEdgeTrimConfig ?? false)
                            }
                          >
                            <Checkbox
                              disabled={action === "view"}
                              onChange={(e) => setZeroEdgeTrimConfig(e.target.checked)}
                            >
                              <span style={{ color: '#323130', fontSize: '12px', fontFamily: 'var(--sf-pro-text)', fontStyle: 'normal', marginTop: '10px' }}>
                                Zero edge trim for single packet
                              </span>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Effective Deckle Length</label>
                        <p>
                          Effective deckle length to match orders after
                          adjusting for edge trim
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="effective_deckle_length"
                          //rules={[{}]}
                          className=""
                          initialValue={
                            action == "add"
                              ? ""
                              : cutterDetails?.effective_deckle_length
                          }
                        >
                          <Input placeholder="" disabled />
                        </Form.Item>
                        <span style={{
                          position: "absolute",
                          right: "15px",
                          top: "20px",
                          fontSize: "14px",
                          color: "#a19f9d",
                          fontFamily: " var(--sf-pro-text)",
                        }} >{selectedLengthUnit}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Allowed Trim Loss</label>
                        <p>
                          The maximum allowed trim loss in percentage
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_loss"
                          //rules={[{}]}
                          className=""
                          initialValue={
                            action == "add"
                              ? ""
                              : cutterDetails?.maximum_loss
                          }
                        >
                          <Input placeholder="" disabled />
                        </Form.Item>
                        <span className="nonEditable">%</span>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Cutter Specification</h2>
                    <p>
                      The cutter specification will be used in deckle matching
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  {cutterType === "duplex" && (<Row className="centerAlign">
                    <Col span={12}>

                      <div className="boxFieldTitle">
                        <label>Maximum difference in Chop Size</label>
                        <p>The maximum difference allowed in the chop size of both stations </p>

                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_difference_chop_size"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action == "add"
                                  ? ""
                                  : cutterDetails?.maximum_difference_chop_size
                              }
                            >
                              <Input placeholder="Max diff in chop size"
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="max_chop_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_difference_chop_size}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                // onChange={handleSelect}
                                disabled={action === "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                      </Row>
                    </Col>
                  </Row>)}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Cutters</label>
                        <p>The maximum number of cutters which can be placed</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_cutters"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: "Invalid format",
                            },
                            // {
                            //   pattern: new RegExp(/^0*[1-9]\d*$/),
                            //   message: "Max. cutters cannot be zero",
                            // },
                            {
                              validator(_, value) {
                                if (value && value == 0) {
                                  return Promise.reject(
                                    "Max. cutters cannot be zero"
                                  );
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : cutterDetails.maximum_cutters
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              "Enter maximum number of the cutters"
                            }
                            // style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                            onChange={maxCutterValidation}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  {cutterType === "simplex" && (<Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Chop Size</label>
                        <p>The minimum and maximum chop size that can be cut on this cutter</p>

                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_chop_size"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.minimum_chop_size
                              }
                              className=""
                              onChange={validateMinMaxChopSize}
                            >
                              <Input placeholder="Min chop"
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_chop_size"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.maximum_chop_size
                              }
                              className=""
                              onChange={validateMinMaxChopSize}
                            >
                              <Input placeholder="Max chop"
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="chop_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.minimum_chop_size}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                disabled={action === "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {chopSizeValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max. chop size cannot be less than min. chop size
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>)}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Cutter Capacity</label>
                        <p>The daily cutting capacity of the capacity</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DisabledStyles>
                              <Form.Item
                                name="capacity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message:
                                      "Upto 3 decimal point values is accepted",
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : cutterDetails?.capacity
                                }
                                className=""
                              >
                                <Input
                                  placeholder={"Enter the prod. capacity"}
                                  disabled={action == "view"}
                                  className="disabled-check"
                                //style={{ textTransform: "capitalize" }}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="capacity_unit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  }
                                ]}
                                initialValue={
                                  action == "add"
                                    ? unitData.units_management.weight.default
                                    : cutterDetails?.units?.capacity
                                }
                                className=""
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}

                                >
                                  {unitData.units_management.weight.data.map((weight) => (
                                    <Option key={weight} >
                                      {weightUnit[weight].displayName + ' / day'}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {cutterType === "duplex" && (<Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Station 1 Specification</h2>
                    <p>
                      The station 1 specification will be used in deckle matching
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Deckle Width Range</label>
                        <p>
                          The minimum and maximum deckle width of this cutter
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_width_station_1"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.minimum_width_station_1
                              }
                              className=""
                            >
                              <Input placeholder="Min width"
                                disabled={action === "view"}
                                onChange={stationOneWidthValidation}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_width_station_1"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.maximum_width_station_1
                              }
                              className=""
                            //onChange={setTrimLoss}
                            >
                              <Input placeholder="Max width"
                                disabled={action === "view"}
                                onChange={stationOneWidthValidation}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="station1_width_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_width_station_1}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                onChange={stationOneWidthValidation}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>
                                    {lengthUnit[deckleWidth].displayName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {stationOneWidthValidationError1 ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max Deckle cannot be less than Min Deckle
                          </span>
                        ) : null}
                        {stationOneWidthValidationError2 ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Station deckle cannot be greater than cutter deckle
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Cutters</label>
                        <p>The maximum number of cutters which can be placed</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_cutters_station_1"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: "Invalid format",
                            },
                            // {
                            //   pattern: new RegExp(/^0*[1-9]\d*$/),
                            //   message: "Max. cutters cannot be zero",
                            // },
                            {
                              validator(_, value) {
                                if (value && value == 0) {
                                  return Promise.reject(
                                    "Max. cutters cannot be zero"
                                  );
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : cutterDetails.maximum_cutters_station_1
                          }
                          className=""
                        >
                          <Input
                            placeholder={

                              "Enter maximum number of the cutters"
                            }
                            // style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                            onChange={station1MaxCutterValidation}
                          />
                        </Form.Item>
                        {maxCuttersStation1ValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Station cutters cannot be greater than total number of cutters
                          </span>
                        ) : null
                        }
                      </div>

                    </Col>

                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Chop Size</label>
                        <p>The minimum and maximum chop size that can be cut on this cutter</p>

                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_chop_size_station_1"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.minimum_chop_size_station_1
                              }
                              className=""

                            >
                              <Input placeholder="Min chop"
                                onChange={validateStation1MinMaxChopSize}
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_chop_size_station_1"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action === "add" ? "" : cutterDetails.maximum_chop_size_station_1
                              }
                            >
                              <Input placeholder="Max chop"
                                disabled={action === "view"}
                                onChange={validateStation1MinMaxChopSize}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="station1_chop_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_chop_size_station_1}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                disabled={action === "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {chopSizeStation1ValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max. chop size cannot be less than min. chop size
                          </span>
                        ) : null
                        }

                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>)}
              {cutterType === "duplex" && (<Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Station 2 Specification</h2>
                    <p>
                      The station 2 specification will be used in deckle matching
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Deckle Width Range</label>
                        <p>
                          The minimum and maximum deckle width of this cutter
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_width_station_2"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action === "add" ? "" : cutterDetails.minimum_width_station_2
                              }
                            >
                              <Input placeholder="Min width"
                                disabled={action === "view"}
                                onChange={station2WidthValidation}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_width_station_2"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action === "add" ? "" : cutterDetails.maximum_width_station_2
                              }
                              className=""
                            //onChange={setTrimLoss}
                            >
                              <Input placeholder="Max width"
                                disabled={action === "view"}
                                onChange={station2WidthValidation}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="station2_width_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_width_station_2}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                onChange={station2WidthValidation}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>
                                    {lengthUnit[deckleWidth].displayName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {stationTwoWidthValidationError1 ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max Deckle cannot be less than Min Deckle
                          </span>
                        ) : null}
                        {stationTwoWidthValidationError2 ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Station deckle cannot be greater than cutter deckle
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Cutters</label>
                        <p>The maximum number of cutters which can be placed</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_cutters_station_2"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: "Invalid format",
                            },
                            //  {
                            //    pattern: new RegExp(/^0*[1-9]\d*$/),
                            //    message: "Max. cutters cannot be zero",
                            //  },
                            {
                              validator(_, value) {
                                if (value && value == 0) {
                                  return Promise.reject(
                                    "Max. cutters cannot be zero"
                                  );
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : cutterDetails.maximum_cutters_station_2
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              //   action === "view"
                              //     ? ""
                              //     :
                              "Enter maximum number of the cutters"
                            }
                            onChange={station2MaxCutterValidation}
                            // style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                        {maxCuttersStation2ValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Station cutters cannot be greater than total number of cutters
                          </span>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Chop Size</label>
                        <p>The minimum and maximum chop size that can be cut on this cutter</p>

                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_chop_size_station_2"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action === "add" ? "" : cutterDetails.minimum_chop_size_station_2
                              }
                            >
                              <Input placeholder="Min chop"
                                disabled={action === "view"}
                                onChange={validateStation2MinMaxChopSize}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_chop_size_station_2"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern:
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                  message: "Invalid format",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              className=""
                              initialValue={
                                action === "add" ? "" : cutterDetails.maximum_chop_size_station_2
                              }
                            >
                              <Input placeholder="Max chop"
                                disabled={action === "view"}
                                onChange={validateStation2MinMaxChopSize}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="station2_chop_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_chop_size_station_2}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                disabled={action === "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {chopSizeStation2ValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max. chop size cannot be less than min. chop size
                          </span>
                        ) : null
                        }
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>)}
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this cutter</p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Reel Diameter Range</label>
                        <p>
                          The minimum and maximum allowed reel diameter of this cutter
                        </p>
                      </div>
                    </Col>

                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_dia_range"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern: /^[0-9]*$/,
                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^[1-9]\d*$/),
                                  message: "Invalid format",
                                },
                              ]}
                              className=""
                              //onChange={setTrimLoss}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : cutterDetails?.minimum_reel_dia
                              }
                            >
                              <Input
                                placeholder="Min Dia"
                                onChange={validateMinMaxDia}
                                disabled={action == "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_dia_range"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern: /^[1-9]*$/,
                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^[1-9]\d*$/),
                                  message: "Invalid format",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : cutterDetails?.maximum_reel_dia
                              }
                              className=""
                            //onChange={setTrimLoss}
                            >
                              <Input
                                placeholder="Max Dia"
                                disabled={action == "view"}
                                onChange={validateMinMaxDia}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item name="dia_unit" initialValue={action == 'add' ? unitData.units_management.length.default : cutterDetails.units.maximum_reel_dia}>
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map((deckleWidth) => (
                                  <Option key={deckleWidth}>
                                    {lengthUnit[deckleWidth].displayName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        {maxDiaValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Min dia should be less than max dia
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Loading Stands</label>
                        <p>The number of loading stands present this cutter</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="loading_stands"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0*[1-9][0-9]*)$/,
                              message: "Only numeric characters greater than zero are allowed",
                            },
                            // {
                            //   pattern: new RegExp(/\d*[0-9]\d*/),
                            //   message: "Loading stand cannot be zero",
                            // },
                          ]}
                          initialValue={
                            action === "add" ? "" : cutterDetails.loading_stands
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              "Enter number of the stands"
                            }
                            // style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The cutter can only be used if it is set to active
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={
                            action === "add" ? "active" : cutterDetails.status
                          }
                        >
                          <Radio.Group
                            disabled={action === "view"}
                            options={statusData}
                            value={status}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>
                          Any other information related to this cutter
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            initialValue={
                              action === "add" ? "" : cutterDetails.remarks
                            }
                            className=""
                          >
                            <TextArea
                              disabled={action === "view"}
                              maxLength={200}
                              style={{ height: 90 }}
                              placeholder={
                                action === "add" || action === "edit"
                                  ? "Enter remarks"
                                  : ""
                              }
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={viewDelete}
        icon={warning}
        cancelAction={modalCancelDelete}
        confirmAction={modalConfirmDelete}
      >
        <span>Delete Cutter?</span>
        <p>
          You are about to delete the cutter. Once deleted it cannot be
          recovered. Are you sure you want to continue ?
        </p>
      </ConfirmationModal>


      {addToastr && (
        <AlertContainer color="green toaster" icon={alertGreen} msg={addResp} />
      )}
      {deleteToastr && (
        <AlertContainer color="red toaster" icon={alertRed} msg={addResp} />
      )}
    </RightLayoutContainer>
  ) : null;
};

export default AddEditViewCutter;
